var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticStyle:{"color":"black"},attrs:{"to":this.fullPath}},[_c('div',{attrs:{"id":"gameContainer"}},[_c('v-avatar',{attrs:{"color":"indigo","size":"128"}},[_c('v-img',{attrs:{"src":this.logoPath}})],1),_c('p',{staticClass:"text-center text-h5"},[_vm._v(_vm._s(this.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }